module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-content sort-type",
    attrs: {
      "id": "mypage-edu-job-link-template"
    }
  }, [_c('div', {
    staticClass: "job-list-container"
  }, [(_vm.totalCount === 0) ? _c('div', {
    staticClass: "no-data"
  }, [_vm._v("지원 가능한 교육 연계 공고가 없습니다.")]) : _c('div', {
    staticClass: "job-card-grid new-type"
  }, _vm._l((_vm.normalizedDisplayedList), function(item, index) {
    return _c('JobCard', {
      key: index,
      attrs: {
        "item": item
      },
      on: {
        "favorite-toggle": _vm.toggleFavorite
      }
    })
  }), 1), _vm._v(" "), (_vm.totalCount > _vm.viewCount) ? _c('div', {
    staticClass: "button-area btn-load-more"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.more
    }
  }, [_c('i', {
    staticClass: "ico ico-plus"
  }), _vm._v("\n        더보기\n      ")])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-933c3f88"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/main/education/MypageEducationJobLink.vue
// module id = 1484
// module chunks = 6